export default {
    authAppleEnabled: false,
    authEmailEnabled: false,
    authGoogleEnabled: false,
    paymentsEnabled: false,
    paymentsApplePayEnabled: false,
    paymentsGooglePayEnabled: false,
    profileCountersEnabled: false,
    defaultLanguage: 'en',
}